module.exports = __webpack_public_path__ + "static/img/001.c31b033b.png";